import { useRouteError } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

/**
 * ErrorBoundary global para React Router.
 * - En PROD: solo muestra "Algo salió mal" + botón Inicio. CERO detalles.
 *   Nada va a consola del navegador (silenciamos también createRoot).
 * - En DEV: muestra mensaje + stack para debuggear.
 */
export default function ErrorBoundary() {
  const error = useRouteError();

  if (import.meta.env.DEV) {
    return <DevErrorView error={error} />;
  }

  return <ProdErrorView />;
}

function ProdErrorView() {
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="text-center">
        <h1 className="display-3 fw-bold mb-4">Algo salió mal</h1>
        <a href="/" className="btn btn-primary btn-lg">
          Inicio
        </a>
      </div>
    </Container>
  );
}

function DevErrorView({ error }: { error: unknown }) {
  // En dev SÍ queremos ver detalles completos.
  // eslint-disable-next-line no-console
  console.error('[ErrorBoundary][dev]', error);

  let message = 'Error desconocido';
  let stack: string | undefined;

  if (error instanceof Error) {
    message = error.message;
    stack = error.stack;
  } else if (typeof error === 'string') {
    message = error;
  } else {
    try { message = JSON.stringify(error, null, 2); } catch { /* keep default */ }
  }

  return (
    <Container className="py-4">
      <div className="alert alert-danger">
        <h4 className="alert-heading">
          <i className="ph ph-warning-circle me-2" />
          ErrorBoundary (dev)
        </h4>
        <p className="mb-2 fw-semibold">{message}</p>
        {stack && (
          <pre className="bg-dark text-white rounded p-3 mb-0" style={{ fontSize: '0.8rem', overflow: 'auto', maxHeight: 400 }}>
            {stack}
          </pre>
        )}
        <hr />
        <a href="/" className="btn btn-outline-primary btn-sm">
          <i className="ph ph-house me-1" />Inicio
        </a>
      </div>
    </Container>
  );
}
